import React, { useState } from "react";
import { connect } from "react-redux";
import { Link, Redirect , NavLink } from "react-router-dom";
import { setAlert } from "../../actions/alert";
import PropTypes from "prop-types";

const HomePageVideo = () => {

  function scrollToTop() {
    window.scrollTo(0, 0);
} 
  
  return (
    <section className="main-introduction" >
       <div className="container">
                <section className="video-widget">
                <div class="v2_111">
                <div class="v2_112"></div>
                <span class="v2_113">Embark on a cybersecurity journey at CyberToCyber, where individuals and businesses converge. Discover tailored solutions, connect with top-tier experts, and fortify your digital presence all seamlessly integrated into one powerful platform.</span>
                    <Link to={'/login'} onClick={scrollToTop} class="v2_114">
                      <span class="v2_115">Get Started</span>
                        <div class="name"></div>
                    </Link>
        
                    <div style={{display: "flex", flexDirection: "column"}}>
                  
                    <span class="v2_117"><span style={{color: "#2F327D"}}>CyberToCyber</span> <span style={{color: "#00CBB8"}}> Your All-in-One Destination for Personal and Business Cybersecurity</span></span>
                    {/*<span class="v2_117_1"></span>*/}
                    </div>
                    {/*Right*/}
                    
                    <div className="VideoSec">
                        <div class="v2_119" ></div>
                        <div class="v2_118"></div>

                        {/*Image div */}
                        <div class="v2_120">
                        <div class="v2_121" ></div>
                        </div>
                         {/*Image div */}
                        
                    </div>
                    <div class="v2_125"></div>
                </div>
                </section>
            </div>
    </section>
  );
};


export default connect()(HomePageVideo);